module.exports = __webpack_public_path__ + "static/Jackalwere-4e2b39031fa1931b70489a22c79b21e7.jpg";